import React from "react";

function Icon({ fillHover }) {
	return (
		<svg
			xmlns='http://www.w3.org/2000/svg'
			width='34'
			height='36'
			fill='none'
			id='svgRes'
			viewBox='0 0 34 36'>
			<path
				fill='#fff'
				className={fillHover}
				d='M32.027 19.947l-5.879 3.327-5.272-5.24 5.314-5.281 5.837 3.303a2.235 2.235 0 010 3.891zM1.005 1.386a2.23 2.23 0 00-.168.852v31.525c0 .326.068.629.186.9l16.733-16.63L1.006 1.386zm18.31 15.098l4.888-4.858L4.175.293a2.199 2.199 0 00-1.42-.269l16.56 16.46zm0 3.1l-16.5 16.4c.448.053.919-.025 1.36-.275l19.986-11.31-4.845-4.815z'></path>
		</svg>
	);
}

export default Icon;
